var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 1.5L3.83908 10.5H2.5L3.97342 1.5H5.3125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1C2.5 0.723858 2.72386 0.5 3 0.5H7C7.27614 0.5 7.5 0.723858 7.5 1C7.5 1.27614 7.27614 1.5 7 1.5H3C2.72386 1.5 2.5 1.27614 2.5 1Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11C0.5 10.7239 0.723858 10.5 1 10.5H5C5.27614 10.5 5.5 10.7239 5.5 11C5.5 11.2761 5.27614 11.5 5 11.5H1C0.723858 11.5 0.5 11.2761 0.5 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorItalic);
export default __webpack_public_path__ + "static/media/editor-italic.b7918a9ed87c396648b5b69d779c94e5.svg";
export { ForwardRef as ReactComponent };